module.exports = __webpack_public_path__ + "static/media/question.f32d8404.svg";